import styled from 'styled-components';

import { themeBase } from 'constants/styles/global';

export const StyledRedefinePasswordForm = styled.form`
    display: flex;
    flex-flow: row wrap;
    column-gap: 5rem;
    row-gap: 1.5rem;
    padding-top: 1.5rem;

    .redefine-password-fields {
        display: flex;
        flex-flow: column nowrap;
        row-gap: 1.5rem;
        width: 300px;
    }

    .efz-alert {
        height: fit-content;
    }

    input[type='password']::-ms-reveal,
    input[type='password']::-ms-clear {
        display: none;
    }
`;

export const StyledPasswordBullets = styled.ul`
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    margin: 1rem 0 0;
    padding: 0;
    list-style: none;
`;

/** A rule of the info box: an arrow until something is typed, then a cross or, struck through, a check. */
export const StyledPasswordBullet = styled.li<{ $state: 'pending' | 'met' | 'unmet' }>`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    column-gap: 0.5rem;
    font-size: 0.875rem;
    font-weight: ${themeBase.fontWeight.normal};
    text-decoration: ${({ $state }) => ($state === 'met' ? 'line-through' : 'none')};

    svg {
        width: 15px;
        height: 15px;
        flex-shrink: 0;

        path {
            fill: ${({ $state }) =>
                $state === 'met' ? 'var(--green-600)'
                : $state === 'unmet' ? 'var(--danger)'
                : 'var(--blue-600)'};
        }
    }
`;
